import React from 'react';
import PeakLogo from '../ui/PeakLogo';
import Button from '../ui/Button';
import Container from './Container';
import { colors, font } from '../../lib/tokens';

// Slim navbar for standalone pages (/press, /brand) — same shell as Navbar,
// but links back to the landing page instead of scrolling to sections.
export default function SubpageNav({ current }: { current: 'press' | 'brand' }) {
  const links = [
    { label: 'Press kit', href: '/press', id: 'press' },
    { label: 'Brand manual', href: '/brand', id: 'brand' },
  ];
  return (
    <div
      style={{
        borderBottom: `1px solid ${colors.hair}`,
        background: 'rgba(250, 250, 247, 0.85)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        position: 'sticky',
        top: 0,
        zIndex: 20,
      }}
    >
      <Container
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: 72,
        }}
      >
        <a href="/" className="kc-logo-link" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <PeakLogo color={colors.ink} accent={colors.blue} size={30} />
        </a>
        <nav
          style={{ gap: 32, fontSize: 14, color: colors.ink2, fontFamily: font.sans }}
          className="hidden md:flex"
        >
          <a href="/" className="kc-nav-link" style={{ textDecoration: 'none' }}>
            ← Back to site
          </a>
          {links.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className={current === link.id ? undefined : 'kc-nav-link'}
              aria-current={current === link.id ? 'page' : undefined}
              style={{
                color: current === link.id ? colors.ink : undefined,
                fontWeight: current === link.id ? 600 : 400,
                textDecoration: 'none',
              }}
            >
              {link.label}
            </a>
          ))}
        </nav>
        <Button variant="primary" href="mailto:info@katlacode.ai">Contact us</Button>
      </Container>
    </div>
  );
}
